
import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'

import configMng from './component/config/configManager'
import shici from './component/shici/shici'
import shicigame from './component/shici/shicigame'
import shicifetch from './component/shici/shicifetch'
import genericLogin from './component/auth/GenericLogin'
import managerLogin from './component/manager/ManagerLogin'
import managerLayout from './component/manager/ManagerLayout'
import managerUsers from './component/manager/ManagerUsers'
import managerLogs from './component/manager/ManagerLogs'
import shicibackup from './component/shici/shicibackup'
import shicimng from './component/shici/shicimng'
import biji from './component/biji/biji'
import bijimng from './component/biji/bijimng'
import travel from './component/travel/travel'
import travelmng from './component/travel/travelmng'
import yqdebug from './component/yqdebugremote/yqdebug'
import autotest from './component/autotestdevice/autotest'
import productManager from "~/component/autotestdevice/productManager";
import deviceManager from "~/component/autotestdevice/deviceManager";
import testItemManager from "~/component/autotestdevice/testItemManager";
import testItemAction from "~/component/autotestdevice/testItemAction";
import feitian from "~/component/feitian/feitian";

Vue.use(VueRouter)
Vue.use(VueAxios, axios)

const routers = [
  {
    "path":"/configManager",
    "name":"configManager",
    component: configMng
  },
  {
    "path":"/shici",
    "name":"sici",
    component: shici
  },
  {
    "path":"/shicigame",
    "name":"shicigame",
    component: shicigame,
    meta: { requiresAuth: true }
  },
  {
    "path":"/shicibackup",
    "name":"shicibackup",
    component: shicibackup,
    meta: { requiresAuth: true }
  },
  {
    "path":"/shicifetch",
    "name":"shicifetch",
    component: shicifetch,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    "path":"/login",
    "name":"login",
    component: genericLogin
  },
  {
    "path":"/shicilogin",
    redirect: to => ({ path: '/login', query: to.query })
  },
  {
    // 独立的后台管理入口：/manager（登录页独立于布局路由）
    "path":"/manager/login",
    "name":"managerLogin",
    component: managerLogin
  },
  {
    "path":"/manager",
    "component": managerLayout,
    "children": [
      {
        "path":"",
        redirect: "/manager/users"
      },
      {
        "path":"users",
        "name":"managerUsers",
        component: managerUsers,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        "path":"logs",
        "name":"managerLogs",
        component: managerLogs,
        meta: { requiresAuth: true, requiresAdmin: true }
      }
    ]
  },
  {
    "path":"/shicimng",
    "name":"shicimng",
    component: shicimng,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    "path":"/biji",
    "name":"biji",
    component: biji
  },
  {
    "path":"/bijimng",
    "name":"bijimng",
    component: bijimng,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    "path":"/travel",
    "name":"travel",
    component: travel
  },
  {
    "path":"/travelmng",
    "name":"travelmng",
    component: travelmng,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    "path":"/",
    "name":"sici",
    component: shici
  },
  {
    "path":"/debug_yqsl",
    "name":"debugyqsl",
    component: yqdebug
  },
  {
    "path":"/autotest",
    "name":"autotest",
    component: autotest
  },
  {
    "path":"/autotest/deviceManager",
    "name":"deviceManager",
    component: deviceManager
  },
  {
    "path":"/autotest/productManager",
    "name":"productManager",
    component: productManager
  },
  {
    "path":"/autotest/testItemAction",
    "name":"testItemAction",
    component: testItemAction
  },
  {
    "path":"/autotest/testItemManager",
    "name":"testItemManager",
    component: testItemManager
  },
  {
    "path":"/feitian",
    "name": "feitian",
    component: feitian
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // 直接使用 routers 就是错误的，这也是个特殊的语法，挺奇怪
  routes: routers
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(r => r.meta && r.meta.requiresAuth)
  const requiresAdmin = to.matched.some(r => r.meta && r.meta.requiresAdmin)

  let token = ""
  try {
    token = String(localStorage.getItem('shicigame_token') || "")
  } catch (e) {
    token = ""
  }

  if (requiresAuth && !token) {
    if (to.path.indexOf('/manager') === 0) {
      next({ path: '/manager/login', query: { redirect: to.fullPath } })
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
    return
  }

  if (requiresAdmin) {
    let user = {}
    try {
      user = JSON.parse(localStorage.getItem('shicigame_user') || '{}') || {}
    } catch (e) {
      user = {}
    }
    if (user.role !== 'admin') {
      if (to.path.indexOf('/manager') === 0) {
        next({ path: '/manager/login', query: { redirect: to.fullPath } })
      } else {
        next({ path: '/shicigame' })
      }
      return
    }
  }

  next()
})

export default router
